import { Injectable, inject } from '@angular/core';
import { Query } from '@datorama/akita';
import { FeeSummary } from '../../../closing-cost-worksheet-15/models/ccw.models';
import { CmgCcwFeeSummaryStore } from './ccw-fee-summary.store';
import { DirtyChecker2 } from '../../core/dirty-checker-2';

@Injectable({ providedIn: 'root' })
export class CmgCcwFeeSummaryQuery extends Query<FeeSummary> {
  protected store: CmgCcwFeeSummaryStore;

  dirtyChecker2: DirtyChecker2 = new DirtyChecker2(this.store, this);

  constructor() {
    const store = inject(CmgCcwFeeSummaryStore);

    super(store);

    this.store = store;
  }

  setHead() {
    this.dirtyChecker2.dirtyChecker.setHead();
  }
}
